import {ClubTypeImage} from "./ClubTypeImage";

export class ClubTypes {
    public static readonly Iron: ClubTypeImage = {
        topImgPath: "Images/ClubControl/Iron_top.png",
        sideImgPath: "Images/ClubControl/Iron_side.png",
        sideCoef: {
            imageClubHeight: 73,
            imageClubWidth: 750,
            xImage: -29,
            yImage: -692,
            xBall: 27,
            initialRotation: 24
        },
        topCoef: { imageClubHeight: 63, imageClubWidth: 750, xImage: -33, yImage: -680, xBall: -25 }
    };
    public static readonly Wedge: ClubTypeImage = {
        topImgPath: "Images/ClubControl/Wedge_top.png",
        sideImgPath: "Images/ClubControl/Wedge_side.png",
        sideCoef: {
            imageClubHeight: 229 / 2,
            imageClubWidth: 973 / 2,
            xImage: -130 / 2,
            yImage: -905 / 2,
            xBall: -50 / 2,
            initialRotation: 46
        },
        topCoef: { imageClubHeight: 201 / 2, imageClubWidth: 895 / 2, xImage: -118 / 2, yImage: -767 / 2, xBall: -25 }
    };
    public static readonly Driver: ClubTypeImage = {
        topImgPath: "Images/ClubControl/Driver_top.png",
        sideImgPath: "Images/ClubControl/Driver_side.png",
        sideCoef: {
            imageClubHeight: 218,
            imageClubWidth: 750,
            xImage: -120,
            yImage: -695,
            xBall: -176,
            initialRotation: 12
        },
        topCoef: { imageClubHeight: 176, imageClubWidth: 750, xImage: -95, yImage: -650, xBall: -22 }
    };
    public static readonly Wood: ClubTypeImage = {
        topImgPath: "Images/ClubControl/Wood_top.png",
        sideImgPath: "Images/ClubControl/Wood_side.png",
        sideCoef: {
            imageClubHeight: 218,
            imageClubWidth: 750,
            xImage: -113,
            yImage: -713,
            xBall: -176,
            initialRotation: 12
        },
        topCoef: { imageClubHeight: 176, imageClubWidth: 750, xImage: -90, yImage: -669, xBall: -22 }
    };
    public static readonly Hybrid: ClubTypeImage = {
        topImgPath: "Images/ClubControl/Hybrid_top.png",
        sideImgPath: "Images/ClubControl/Hybrid_side.png",
        sideCoef: {
            imageClubHeight: 103,
            imageClubWidth: 750,
            xImage: -46,
            yImage: -720,
            xBall: 176,
            initialRotation: 20
        },
        topCoef: { imageClubHeight: 89, imageClubWidth: 750, xImage: -45, yImage: -681, xBall: -22 }
    };
}